import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

import { AccountTicketsFacade, RelatedCardFacade } from '@ridango/components';
import {
    RelatedCard,
    UserTicketAction,
    UserTicketActionCarrier,
    CoreFacade,
    Language,
    AllowedPathService
} from '@ridango/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'rwidget-account-related-card-tickets',
    templateUrl: './account-related-card-tickets.component.html',
    styleUrls: ['./account-related-card-tickets.component.scss']
})
export class AccountRelatedCardTicketsComponent implements OnInit, OnDestroy {
    private componentDestroyed$ = new Subject<void>();

    selectedRelatedCard$: Observable<RelatedCard> = this.relatedCardFacade.selectedCard$;
    accountTicketsLoaded$: Observable<boolean> = this.accountTicketsFacade.loaded$;
    tickets$: Observable<any> = this.accountTicketsFacade.selectedRelatedCardTickets$;
    selectedTicket$: Observable<any> = this.accountTicketsFacade.selectedTicket$;

    selectedLanguageCode = this.translate.currentLang;
    selectedLanguage$: Observable<Language> = this.coreFacade.selectedLanguage$;
    useInputActions = true;

    @Input() ticketActions: UserTicketAction[] = [];
    @Output() onNavigateRequest = new EventEmitter();

    isWebPurchaseAllowed = this.pathService.isWebPurchaseAllowed();
    constructor(
        private translate: TranslateService,
        private accountTicketsFacade: AccountTicketsFacade,
        private relatedCardFacade: RelatedCardFacade,
        private coreFacade: CoreFacade,
        private pathService: AllowedPathService
    ) {}

    ngOnInit() {
        this.selectedLanguage$.pipe(takeUntil(this.componentDestroyed$)).subscribe((l: Language) => {
            if (l?.code) {
                this.selectedLanguageCode = l.code;
            }
        });
    }

    ngOnDestroy() {
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }

    ticketAction(action: UserTicketActionCarrier) {
        console.log('AccountRelatedCardTicketsComponent ticketAction', action);
    }

    navigate() {
        this.onNavigateRequest.emit();
    }
}
